import { render, staticRenderFns } from "./ModalHistorySentInformation.vue?vue&type=template&id=3f84d735&scoped=true"
import script from "./ModalHistorySentInformation.vue?vue&type=script&lang=js"
export * from "./ModalHistorySentInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84d735",
  null
  
)

export default component.exports